import http from '@/shared/config/httpService';
import {
  BooleanUserSettingType,
  IBooleanUserSetting,
} from '@/shared/model/boolean-user-setting.model';

const baseApiUrl = 'api/v1/boolean-user-settings';

export default class BooleanUserSettingService {
  private enumSettings = [{ key: 'MARKETING_COVER', label: 'Deckblatt', order: 0, public: true }];

  /**
   * load all settings
   */
  public async retrieve(): Promise<IBooleanUserSetting[]> {
    return (await http.get(baseApiUrl)).data;
  }

  public async findByType(type: string): Promise<IBooleanUserSetting | null> {
    return (await http.get(baseApiUrl + '/' + type)).data;
  }

  /**
   * saves all given text field settings
   * @param booleanUserSettings array of text field settings
   */
  public saveAll(booleanUserSettings: IBooleanUserSetting[]): Promise<any> {
    return http.put(baseApiUrl + '/all', booleanUserSettings);
  }

  /**
   * get the display string for the given text field type
   * @param key text field type
   */
  public getDisplayString(key: BooleanUserSettingType): string {
    const displayString = this.enumSettings.find(setting => setting.key === key)?.label;
    return displayString || '';
  }

  public sortSettings(unsorted: IBooleanUserSetting[]): IBooleanUserSetting[] {
    //sort text settings by order defined in enumSettings
    return unsorted.sort((a, b) => this.sortByOrder(a, b));
  }

  sortByOrder(a: IBooleanUserSetting, b: IBooleanUserSetting): number {
    const aOrder = this.enumSettings.find(setting => setting.key === a.type)?.order;
    const bOrder = this.enumSettings.find(setting => setting.key === b.type)?.order;
    if (aOrder != null && bOrder != null) {
      return aOrder - bOrder;
    } else {
      return 0;
    }
  }
}
